var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"achievement",class:'achievement--'+_vm.theme+' '+'achievement--'+_vm.config.icon+' '+'achievement--'+(_vm.config.achieved ? 'achieved' : 'not-achieved')})}
var staticRenderFns = []

export { render, staticRenderFns }